var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconUserInCircleBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 34,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  fillRule: "evenodd",
  d: "M17.5 0C8.112 0 .5 7.611.5 17s7.611 17 17 17c9.39 0 17-7.611 17-17s-7.61-17-17-17m0 5.083a5.623 5.623 0 1 1 0 11.247 5.623 5.623 0 0 1 0-11.247M9.372 26.56a12.48 12.48 0 0 0 8.124 2.996c3.1 0 5.937-1.128 8.125-2.996a2.39 2.39 0 0 0 .84-1.82c0-3.15-2.538-5.67-5.689-5.67H14.23c-3.15 0-5.698 2.52-5.698 5.67 0 .699.308 1.366.84 1.82",
  clipRule: "evenodd"
})));
export default SvgIconUserInCircleBlack;